import {
  Component,
  Input,
  Output,
  EventEmitter,
  ContentChild,
  OnChanges,
  TemplateRef,
  AfterViewInit,
  SimpleChanges,
  OnDestroy,
} from "@angular/core";
import * as moment from "moment";
import "moment/locale/zh-cn";
import "moment/locale/zh-tw";
import "moment/locale/ja";
import _ from "lodash";
import { Moment } from "moment";
import { StoreService } from "@root/shared/service/store.service";
import { Subject } from "rxjs";
import { OnLangChangeUntil } from "@root/util/decorator";
import { TranslateService, LangString } from "@root/shared/service/translate.service";

export interface MonthInterface {
  index: number;
  name: string;
  year: number;
  isCurrentMonth: boolean;
  isSelectedMonth: boolean;
}

export interface DayInterface {
  number: number;
  isLastMonth: boolean;
  isNextMonth: boolean;
  isPastDay: boolean;
  isCurrentDay: boolean;
  isSelectedDay: boolean;
  isHoliday: boolean;
  holidayName: string;
  isLegalHoliday: boolean;
  isOff: boolean;
  title: string;
  week: number;
  date: Moment;

  calendarData: any;
  dayOfWeek: number;
  // disabled: boolean;
  // firstDisabled: boolean;
  // lastDisabled: boolean;
}

export interface WeekInterface {
  days: Array<DayInterface>;
}

// moment.locale('zn', {
//   weekdays: ['一', '二', '三', '四', '五', '六', '日']
// });

@Component({
  selector: "host-calendar",
  template: `
    <dl class="table">
      <dt class="picker-row" *ngIf="showPicker">
        <div class="picker">
          <i
            nz-icon
            nzType="left"
            nzTheme="outline"
            class="arrow-left arrow"
            (click)="prevMonth(); buildCalendar()"></i>
          <!--          <span-->
          <!--            -->
          <!--          ></span>-->
          <span class="current-date">
            {{
              showYear + "-" + (showMonth + 1 > 9 ? showMonth + 1 : "0" + (showMonth + 1)) + "-01" | dateformat: ["YM"]
            }}
            <!-- {{ showYear }}年{{ showMonth + 1 }}月 -->
          </span>
          <i
            nz-icon
            nzType="right"
            nzTheme="outline"
            class="arrow-right arrow"
            (click)="nextMonth(); buildCalendar()"></i>
          <!--          <span class="arrow-right arrow" (click)="nextMonth(); buildCalendar()"></span>-->
        </div>
      </dt>
      <dt class="header-row">
        <ng-template
          [ngIf]="header"
          [ngTemplateOutlet]="header"
          [ngTemplateOutletContext]="{ $implicit: listOfWeekName }"></ng-template>
      </dt>
      <dd class="cell-row" *ngFor="let week of weeksCalendar; let j = index">
        <ng-template
          [ngIf]="reservation"
          [ngTemplateOutlet]="reservation"
          [ngTemplateOutletContext]="{ $implicit: j }"></ng-template>
        <div *ngFor="let day of week.days" class="cell-container">
          <ng-template
            [ngIf]="cell"
            [ngTemplateOutlet]="cell"
            [ngTemplateOutletContext]="{ $implicit: day }"></ng-template>
        </div>
      </dd>
    </dl>
  `,
  styles: [
    `
      :host ::ng-deep .picker-row {
        height: 52px;
        line-height: 52px;
      }
      :host ::ng-deep .picker {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      :host ::ng-deep .arrow {
        display: inline-block;
        width: 23px;
        height: 12px;
        background-size: cover;
        background-position: center;
        cursor: pointer;
        transition: all 0.3s ease;
      }
      :host ::ng-deep .current-date {
        font-size: 16px;
        color: #111112;
      }
      :host ::ng-deep .arrow-left {
        margin-right: 30px;
        /*background-image: url(/assets/direction/arrow-left.png);*/
      }
      :host ::ng-deep .arrow-right {
        margin-left: 30px;
        /*background-image: url(/assets/direction/arrow-right.png);*/
      }
    `,
  ],
})
export class CalendarComponent implements AfterViewInit, OnChanges, OnDestroy {
  @Input() calendarDataList = [];
  @Input() showPicker = true;
  @Input() from: "date" | "calendar" = "calendar";
  @Input() weekLines: 6 | null = null;
  // @Input() weekNameType: weekNameType = weekNameType.short;
  @Output() monthChange = new EventEmitter();
  /**
   * @deprecated
   * @alias with onPrevMonth
   */
  @Output() subRightMonth = new EventEmitter();
  /**
   * @deprecated
   * @alias with onNextMonth
   */
  @Output() addLeftMonth = new EventEmitter();

  // private locale = 'zh-cn';

  weeksCalendar: Array<WeekInterface> = [];
  listOfWeekName: Array<string> = [];
  listOfMonthName: Array<string> = [];
  listOfYearName: Array<string> = [];

  yearUnit = "年";
  monthUnit = "月";
  @Input() showYear = moment(new Date()).year();
  @Input() showMonth = moment(new Date()).month();
  /**
   * @deprecated
   */
  @Output() showYearChange = new EventEmitter(); // 再加上Output模拟数据的双向绑定
  /**
   * @deprecated
   */
  @Output() showMonthChange = new EventEmitter();

  value: Date = new Date();

  @ContentChild("cell") cell: TemplateRef<any>;
  @ContentChild("header") header: TemplateRef<any>;
  @ContentChild("reservation") reservation: TemplateRef<any>;

  private destroy$ = new Subject();

  constructor(
    private storeService: StoreService,
    private translate: TranslateService,
  ) {
    this.buildCalendar();
  }

  ngAfterViewInit() {}

  private getLocale() {
    const lang = this.translate.getCurrentLang();

    if (lang === LangString.ZH) {
      return "zh-cn";
    }
    if (lang === LangString.TW) {
      return "zh-tw";
    }
    if (lang === LangString.JP) {
      return "ja";
    }

    return "en";
  }

  // @OnLangChangeUntil('destroy$')
  buildCalendar() {
    // moment.locale(this.locale);
    /**
     * 语言变化时设置moment对应的语言，从底层更改，无需在逻辑上层翻译日历相关的信息
     */
    moment.locale(this.getLocale());
    this.listOfYearName = this.generateYears(this.showYear);
    // if (this.weekNameType === weekNameType.long) {
    //   this.listOfWeekName = moment.weekdays();
    // } else {
    this.listOfWeekName = moment.weekdaysShort();
    // }
    this.listOfMonthName = moment.months();
    const date = moment(this.value).year(this.showYear).month(this.showMonth);
    this.weeksCalendar = this.buildMonth(date);
  }

  generateYears(year) {
    const listOfYears = [];
    for (const i of Array.from(Array(20).keys())) {
      listOfYears.push(i - 10 + year);
    }
    return listOfYears;
  }

  buildMonth(d: Moment): Array<WeekInterface> {
    const weeks: Array<WeekInterface> = [];
    const rawDate = this.removeTime(d);
    // 获取本月1号所在星期的第一天的日期 如 28 29 30 31 1 2 3 里就是28这天
    const start = rawDate.clone().date(1).day(0);
    const month = rawDate.clone();
    let done = false;
    const date = start.clone();
    // let count = 0;
    if (this.weekLines) {
      for (let i = 0; i < this.weekLines; i++) {
        weeks.push({
          days: this.buildWeek(date.clone(), month),
        });
        date.add(1, "w");
      }
    } else {
      while (!done) {
        weeks.push({
          days: this.buildWeek(date.clone(), month),
        });
        date.add(1, "w");
        if (!date.isSame(d, "month")) {
          done = true;
        }
        // done = ++count > 4;
      }
    }
    return weeks;
  }

  buildWeek(date: Moment, month: Moment): Array<DayInterface> {
    const days: Array<DayInterface> = [];
    const holidays = this.storeService.get(`hostex_holiday_${moment().year()}`, 2);
    for (let i = 0; i < 7; i++) {
      const holiday = holidays && holidays[date.format("YYYY-MM-DD")];
      const holidayName = holiday && holiday.name;
      const isLegalHoliday = holiday && holiday.isLegalHoliday;
      const isOff = holiday && holiday.isOff;
      days.push({
        number: date.date(),
        isLastMonth: date.month() < month.month(),
        isNextMonth: date.month() > month.month(),
        isPastDay: date.isBefore(new Date(), "day"),
        isCurrentDay: date.isSame(new Date(), "day"),
        // 只有房态日历需要默认今天被选中
        isSelectedDay: this.from === "date" ? false : date.isSame(this.value, "day"),
        title: date.format("YYYY-MM-DD"),
        date: date,
        week: date.week(),
        isHoliday: holiday ? true : false,
        holidayName: holidayName,
        isLegalHoliday: isLegalHoliday,
        isOff: isOff,
        calendarData: null,
        dayOfWeek: date.day(),
      });
      date = date.clone();
      date.add(1, "d");
    }
    return days;
  }

  private removeTime(date: Moment): Moment {
    return date.hour(0).minute(0).second(0).millisecond(0);
  }

  public prevYear() {
    this.showYear = this.showYear - 1;
    this.showYearChange.emit(this.showYear);
  }

  public nextYear() {
    this.showYear = this.showYear + 1;
    this.showYearChange.emit(this.showYear);
  }

  public prevMonth() {
    this.subRightMonth.emit({
      year: this.showYear,
      month: this.showMonth,
    });
    if (this.showMonth - 1 < 0) {
      this.showMonth = 11;
      this.prevYear();
    } else {
      this.showMonth = this.showMonth - 1;
    }
    this.showMonthChange.emit(this.showMonth);
    this.monthChange.emit(`${this.showYear}-${this.showMonth + 1}`);
  }

  public nextMonth() {
    this.addLeftMonth.emit({
      year: this.showYear,
      month: this.showMonth,
    });
    if (this.showMonth + 1 > 11) {
      this.showMonth = 0;
      this.nextYear();
    } else {
      this.showMonth = this.showMonth + 1;
    }
    this.showMonthChange.emit(this.showMonth);
    this.monthChange.emit(`${this.showYear}-${this.showMonth + 1}`);
  }

  ngOnChanges(changes: SimpleChanges) {
    // 连选点选的组件需要构建多个月份的日历
    if (changes.showMonth || changes.showYear) {
      this.buildCalendar();
    }
  }

  ngOnDestroy() {
    this.destroy$.next(null);
    this.destroy$.complete();
  }
}
